/* ================================================
   Family Crossword Board — v2
   Standalone renderer + SVG export.
   ================================================ */
/* ================================================
   Family Crossword Board — v2
   ================================================ */
(function () {
  'use strict';

  /* ────────────────────────────────────────────
     CONSTANTS
  ──────────────────────────────────────────── */
  const BW = 1133, BH = 845, BR = 12;
  const TREE_SCALE = BH / 634;
  const TREE_VW = Math.round(389 * TREE_SCALE);
  const RX = TREE_VW;
  const RW = BW - TREE_VW;
  const RPAD = 28;

  const C_BG    = '#3b1f0c';
  const C_TILE  = '#d4a96a';
  const C_TAN   = '#d4a96a';
  const C_RED   = '#ff0000';
  const C_BLUE  = '#0000ff';
  const C_BLACK = '#000000';

  const SCORES = {
    A:1,B:3,C:3,D:2,E:1,F:4,G:2,H:4,I:1,J:8,K:5,L:1,M:3,
    N:1,O:1,P:3,Q:10,R:1,S:1,T:1,U:1,V:4,W:4,X:8,Y:4,Z:10
  };

  const TITLE_FONTS = [
    { label: 'Pacifico',       family: 'Pacifico',       weight: '400' },
    { label: 'Kaushan Script', family: 'Kaushan Script', weight: '400' },
    { label: 'Yellowtail',     family: 'Yellowtail',     weight: '400' },
    { label: 'Lobster',        family: 'Lobster',        weight: '400' },
    { label: 'Cookie',         family: 'Cookie',         weight: '400' },
    { label: 'Satisfy',        family: 'Satisfy',        weight: '400' }
  ];

  const CROSSWORD_FONTS = [
    { label: 'Classic',    family: 'Roboto Slab',   weight: '900' },
    { label: 'Condensed',  family: 'Oswald',        weight: '700' },
    { label: 'Chunky',     family: 'Alfa Slab One', weight: '400' },
    { label: 'Modern',     family: 'Inter',         weight: '900' },
    { label: 'Bold',       family: 'Anton',         weight: '400' },
    { label: 'Rounded',    family: 'Fredoka',       weight: '700' }
  ];

  const TREE_PATH_MAIN   = "M371.132,225.27c-4.515-1.882-8.829-1.244-12.901,1.311c-2.866,1.798-5.59,1.957-8.356-0.133c1.298-1.871,3.133-2.171,5.135-1.964c6.837,0.706,11.466-2.583,14.472-8.877c1.037-2.171,2.124-4.311,2.725-6.583c-0.49-1.091-1.361-0.96-2.137-0.992c-3.588-0.149-7.139,0.13-10.563,1.354c-3.075,1.099-5.512,2.975-6.624,6.395c-0.336,1.032-0.822,2.009-1.242,3.01c-1.638,3.906-4.93,5.687-8.969,4.753c-6.962-1.61-13.921-3.228-20.952-4.477c-2.256-0.401-4.598-0.282-6.768-1.232c1.565-3.064,5.968-7.909,8.399-9.21c1.665,0.492,2.936,1.777,4.333,2.809c4.453,3.287,9.113,3.808,14.018,1.287c3.413-1.754,6.768-3.615,9.606-6.352c-6.075-7.582-16.884-9.5-24.584-4.427c-0.481,0.317-0.957,0.642-1.507,1.011c0.075-2.666,0.075-2.666,1.348-5.558c1.093-0.975,2.477-1.542,3.877-2.103c7.026-2.813,10.619-8.194,10.759-16.148c0.06-3.404,0.08-6.806-0.243-10.111c-0.929-0.775-1.621-0.092-2.323,0.197c-2.702,1.113-5.039,2.913-7.492,4.498c-5.642,3.649-8.394,9-7.863,15.922c0.509,6.639-1.94,12.101-5.302,17.325c-0.311,0.483-0.594,1.05-1.736,1.317c0.634-4.524,2.095-8.995-0.134-13.272c-2.166-4.157-5.3-7.227-9.438-9.686c-1.32,4.562-2.554,8.846-2.072,13.418c0.29,2.75,1.4,5.143,3.458,6.938c1.504,1.312,3.061,2.558,4.598,3.837c0.799,2.132-0.233,3.469-1.759,4.609c-3.415,2.55-7.137,4.435-11.131,5.715c-6.268,2.009-12.542,3.999-18.82,5.975c-0.295,0.093-0.649-0.025-1.032-0.048c0.493-2,1.79-3.451,2.547-5.205c1.725-4,3.173-8.094,4.052-12.389c1.273-6.224,3.32-12.164,5.973-17.851c3.294-7.062,5.722-14.336,5.823-22.311c0.009-0.743,0.181-1.447,0.688-2.188c1.103-1.101,2.5-1.15,4.068-0.912c8.395,1.276,13.354-1.27,17.525-8.978c1.532-2.831,3.085-5.666,4.069-9.27c-5.709-0.526-11.092-0.698-16.28,1.774c-5.352,2.55-7.769,7.666-9.934,13.307c-1.17-2.9-1.961-11.317-1.366-13.453c0.594-2.133,1.783-3.664,3.962-4.104c0.452-0.091,0.912-0.146,1.36-0.255c7.869-1.906,12.32-7.218,13.554-15.531c0.459-3.095,0.499-6.26,0.779-10.057c-6.613,2.386-12.899,4.178-16.937,10.289c-2.065,3.125-2.578,6.717-2.756,10.41c-0.096,1.992-0.027,4.041-1.613,6.515c-1.097-4.244-2.183-7.733-2.113-11.506c0.019-1.041,0.664-1.784,1.107-2.63c4.77-9.112,4.102-16.562-2.26-24.573c-1.331-1.676-2.815-3.218-4.26-4.789c-0.385-0.418-0.743-0.952-1.889-0.984c-3.322,7.666-7.278,15.294-3.021,24.256c1.099,2.314,2.609,4.308,4.336,6.109c2.654,2.767,3.501,6.151,3.354,10.117c-1.999-0.744-2.508-2.563-3.271-4.139c-2.867-5.924-7.306-9.205-13.721-9.366c-3.959-0.099-7.771,0.62-11.549,1.769c1.106,3.746,5.568,10.291,8.276,12.357c4.143,3.16,8.72,3.544,13.518,2.431c1.707-0.396,3.387-0.69,5.587-0.27c4.259,5.398,3.47,12.192,3.859,18.733c-1.506,0.398-1.58-0.814-1.747-1.439c-1.869-6.994-7.579-10.416-17.747-8.368c1.553,3.984,3.134,7.84,6.135,10.804c2.067,2.041,4.783,2.222,7.418,2.501c0.678,0.072,1.379-0.128,2.067-0.11c2.313,0.061,3.392,1.146,3.299,3.636c-0.141,3.799-0.925,7.492-2.424,10.95c-1.389,3.205-2.977,6.313-4.477,9.464c-2.653,5.57-4.233,11.558-6.09,17.44c-3.091,9.788-9.116,17.063-17.424,22.28c-5.295,3.325-11.232,4.355-17.239,4.505c-7.702,0.193-15.334-1.207-23.316-1.542c1.102-3.918,3.242-6.951,5.014-10.148c2.796-5.044,5.581-10.075,7.576-15.554c2.02-5.549,9.457-12.546,15.215-14.257c1.671,7.008,6.817,8.773,13.23,9.245c0.174-4.772-1.291-8.682-4.664-11.61c0.242-0.918,0.722-1.212,1.296-1.357c1.231-0.309,2.48-0.544,3.699-0.896c7.509-2.165,10.418-6.117,10.865-15.042c-4.676-0.577-8.708,1.25-13.018,3.79c1.961-8.676,4.865-16.921,3.856-26.11c-2.481,1.403-2.568,4.273-4.116,6.506c-1.594-5.129-5.369-7.243-9.621-9.209c-0.821,2.307-0.593,4.593-0.617,6.821c-0.026,2.391,0.742,4.54,2.207,6.381c1.442,1.813,3.818,2.236,5.668,4.315c-0.408,6.379-2.378,12.239-7.29,16.759c-1.922,1.769-4.087,3.169-6.32,4.435c-2.519,1.428-5.091,2.751-7.439,4.012c-0.878-0.27-0.846-0.816-0.829-1.259c0.38-9.637-1.883-18.817-4.283-27.979c-1.73-6.605-3.047-13.264-1.748-20.162c0.314-1.668,0.659-3.341,1.144-4.96c2.608-8.69,7.243-16.549,9.096-25.337c1.628-0.861,2.946-0.258,4.282,0.017c5.554,1.144,10.213-0.191,13.742-5.213c2.078-2.958,3.314-6.383,5.63-9.756c-4.881-1.192-9.303-1.944-13.873-0.452c-4.782,1.561-6.706,5.977-9.269,10.026c-0.445-2.993-0.556-5.927-0.151-8.864c0.201-1.456,1.211-2.279,2.406-2.885c1.658-0.84,3.362-1.602,4.947-2.577c4.811-2.959,7.564-7.307,7.929-13.29c0.253-4.139-0.16-8.217-0.574-12.861c-7.758,3.499-14.926,7.077-18.107,16.114c-0.167-4.903-0.959-9.446-4.614-12.797c-3.015-2.764-6.518-4.408-10.568-5.408c-0.538,4.429-0.298,8.538,0.768,12.507c1.091,4.061,3.526,7.314,7.361,8.633c3.839,1.321,5.43,4.169,6.278,7.897c0.781,3.435,0.746,6.902,0.673,10.372c-1.928,0.193-1.945-1.095-2.047-2.118c-0.216-2.181-0.335-4.375-0.978-6.478c-1.309-4.28-3.717-7.473-7.853-9.052c-3.229-1.232-6.398-2.662-9.906-2.767c-0.461,4.206,1.648,12.337,3.877,15.188c2.496,3.193,5.899,4.53,9.602,5.249c1.014,0.197,2.047,0.198,3.034,0.638c2.919,1.3,3.871,3.063,3.159,6.296c-0.495,2.247-1.094,4.469-1.69,6.69c-0.343,1.276-0.752,2.539-2.041,3.624c-1.402-7.168-5.626-10.803-12.382-11.604c-0.51,3.216-0.039,6.264,1.13,9.186c1.048,2.618,2.928,4.328,5.574,5.014c1.358,0.352,2.678,0.744,3.468,2.572c-2.826,6.014-5.717,12.23-6.204,19.309c-0.47,6.837,0.833,13.529,1.572,20.236c-1.28,0.313-1.704-0.578-2.245-1.112c-3.453-3.408-6.954-6.77-10.27-10.323c-2.5-2.679-4.824-5.577-5.041-9.57c0.891-1.69,2.408-2.427,3.708-3.388c3.738-2.763,5.441-6.468,4.987-11.285c-0.261-2.776-0.458-5.561-1.466-8.487c-4.739,2.395-8.627,5.549-10.892,11.341c-0.984-3.001-0.363-5.733-1.544-8.1c-2.364,8.329-0.298,16.392,1.556,25.009c-5.689-2.646-10.272-1.032-14.455,3.761c2.289,2.385,4.881,4.28,8.003,5.084c3.456,0.89,6.075-1.775,8.905-2.889c0.937-0.012,1.415,0.554,1.863,1.098c4.087,4.957,8.246,9.851,12.213,14.913c5.525,7.051,7.218,15.376,5.241,24.045c-2.905,12.741-8.488,24.098-17.676,33.267c-6.72,6.706-13.915,12.716-21.771,17.858c-0.897,0.587-1.749,1.24-2.559,1.942c-9.927,8.596-21.415,13.643-33.822,16.53c-4.151,0.966-8.372,1.598-12.562,2.382c-4.648,0.87-9.221,2.04-13.64,3.823c-1.058,0.427-2.126,0.824-3.144,1.217c-1.043-1.068-0.735-2.19-0.494-3.186c1.091-4.516,3.212-8.317,7.081-10.808c3.144-2.024,6.334-3.97,9.455-6.034c3.988-2.638,7.101-6.176,9.303-10.581c1.72-3.441,3.391-6.9,4.619-10.591c1.305-3.924,3.115-7.593,5.575-10.865c2.517-3.348,7.967-4.618,12.244-2.62c-0.604,5.284-2.071,10.981,2.211,15.62c2.935,3.18,6.475,5.315,10.571,7.153c1.24-5.516,1.597-10.598-0.264-15.697c-1.915-5.247-6.698-7.046-11.079-9.975c2.637-1.796,4.879-3.323,7.026-4.785c1.591,0.903,1.712,2.28,1.799,3.595c0.424,6.431,3.917,10.26,9.473,12.024c3.257,1.034,6.68,1.484,10.171,2.227c-2.265-12.913-3.567-17.864-18.349-20.415c0.624-2.19,2.112-1.916,3.544-1.393c2.083,0.761,4.173,1.219,6.394,1.312c3.364,0.141,6.602-1.131,9.012-3.483c3.186-3.109,5.743-6.748,8.188-10.72c-2.499-2.104-5.482-2.184-8.207-2.546c-7.566-1.005-13.749,1.211-17.739,8.836c-3.841,7.339-10.348,10.656-17.917,12.019c-0.517-1.284,0.347-1.717,0.844-2.287c3.327-3.815,7.411-6.554,11.692-8.968c2.5-1.41,4.53-3.293,6.172-5.711c3.089-4.548,2.309-9.48,1.256-14.404c-0.215-1.008-0.193-2.229-1.539-3.253c-3.334,2.634-7.225,4.754-9.433,8.972c-2.3,4.394-0.836,9.016-0.504,13.706c-12.389,5.537-19.87,16.19-26.312,27.969c-1.902-3.34-1.545-10.95,1.096-23.97c2.891-2.541,7.205-3.84,8.179-8.643c0.556-2.74,0.123-6.735-1.218-9.727c-3.734,2.37-7.592,4.497-9.631,9.622c-1.072-3.539-1.954-6.452-2.904-9.59c-1.61,0.962-1.589,2.32-1.693,3.601c-0.191,2.359,0.507,4.579,0.999,6.828c1.118,5.11,1.203,8.507,0.162,12.246c-2.782-5.475-7.1-7.903-12.984-8.134c-0.1,3.875,0.554,7.458,2.086,10.924c1.648,3.728,5.202,4.518,8.037,5.947c0.783,1.103,0.568,2.106,0.537,3.055c-0.109,3.291-0.171,6.584,0.201,9.856c0.824,7.24-2.53,12.103-7.999,15.707c-1.749,1.153-3.631,2.121-5.535,2.966c-8.71,3.866-14.226,10.903-17.789,19.881c-0.935,2.355-1.959,4.676-2.853,7.036c-1.735,4.58-4.957,7.565-8.792,9.939c-6.637,4.108-12.391,9.266-17.245,15.571c-1.459,1.896-3.159,3.562-5.12,4.872c-2.261,1.51-4.143,1.072-5.608-1.303c-1.286-2.085-1.686-4.517-2.138-6.897c-2.287-12.057-4.082-24.203-5.366-36.421c-0.719-6.843-0.02-13.645,1.859-20.234c3.338-11.707,7.538-22.992,15.104-32.523c1.84-2.318,1.8-2.353,4.246-3.531c7.287,2.145,10.487,8.187,8.279,15.751c-0.161,0.552-0.516,1.423-0.725,1.959c-1.975,5.076-1.265,9.893,1.57,14.524c0.244,0.399,0.393,0.862,0.783,1.738c-3.958,1.406-7.477,3.437-8.96,7.796c-0.97,2.852-1.417,5.814-1.299,8.859c7.153,0.155,11.857-3.709,14.968-12.028c-0.367,3.915-1.61,7.886,0.721,11.597c1.636,2.605,3.868,4.438,6.597,6.073c2.076-4.04,2.72-8.24,2.264-12.648c-0.184-1.775-1.099-3.242-2.488-4.223c-3.355-2.369-5.467-5.862-7.752-9.223c-2.604-3.832-2.947-7.812-0.933-12.025c0.413-0.865,0.792-1.748,1.19-2.63c1.436-0.014,1.6,1.293,2.149,2.106c1.803,2.668,3.178,5.681,5.608,7.84c1.452,1.289,2.881,2.667,5.044,2.958c0.358-2.308-1.637-3.047-2.181-4.936c6.17,2.292,10.41-0.609,14.165-5.405c-3.175-3.232-6.904-3.99-11.191-3.788c1.227-3.655,2.062-7.162,0.337-10.682c-6.265,1.588-8.228,3.948-9.02,11.775c-4.04-7.147-6.547-14.878-12.606-20.447c3.878-2.072,7.835-2.898,11.703-3.903c9.594-2.492,18.652-6.049,26.392-12.852c5.252-4.617,9.107-10.261,12.169-16.617c1.416-2.94,3.014-5.71,5.537-7.825c2.956-2.478,6.186-4.22,9.922-4.795c2.827-0.435,5.67-0.746,8.682-1.135c2.154,4.603,3.727,9.685,8.863,11.578c4.528,1.669,9.061,0.826,13.949,0.187c-1.765-4.83-3.792-9.055-7.432-12.049c-3.805-3.13-8.249-3.07-13.123-1.568c2.748-4.078,5.086-4.953,8.533-3.535c1.498,0.616,2.919,1.455,4.525,1.751c4.567,0.843,8.687-0.04,12.196-3.447c2.697-2.619,5.744-4.89,7.624-8.762c-6.533-3.013-12.863-5.739-19.901-2.142c-2.683,1.371-4.56,3.653-6.438,5.974c-1.023,1.263-1.936,2.783-4.129,2.585c1.5-3.686,1.648-7.294,0.034-10.858c-5.125,1.003-7.119,5.228-6.59,13.916c-0.726,1.435-2.108,1.893-3.458,1.964c-4.261,0.224-8.481,0.719-12.67,1.562c-0.296,0.06-0.638-0.132-0.874-0.187c-0.499-0.628-0.385-1.259-0.272-1.828c0.875-4.405,1.663-8.833,3.141-13.078c2.829-8.124,7.142-11.329,15.386-11.323c4.718,0.003,9.37,1.002,14.121,0.843c7.444-0.25,14.607-5.916,14.84-17.608c-3.012,4.152-4.536,8.876-9.375,11.112c2.004-5.009,1.481-9.548-0.125-14.438c-3.146,1.392-5.762,3.181-7.593,6.083c-1.87,2.963-0.519,6.414-1.107,9.897c-4.94,0.295-9.565-1.621-14.608-1.489c0.021-2.323,1.102-3.841,2.315-5.232c2.576-2.954,5.213-5.85,7.841-8.753c3.515-3.885,6.602-8.124,9.329-12.652c0.802-1.332,1.66-2.345,3.559-1.929c0.968,1.257,1.604,2.936,2.363,4.554c2.07,4.411,5.428,6.862,10.127,6.995c2.762,0.078,5.529-0.015,8.293-0.09c0.768-0.021,1.645,0.134,2.202-0.703c-3.813-9.825-8.077-17.7-23.238-13.563c0.138-2.972,2.685-5.34,5.627-5.142c1.376,0.092,2.742,0.343,4.111,0.538c5.465,0.782,9.912-1.155,13.607-5.436c3.227-3.739,5.217-8.147,7.236-13.134c-7.055-0.881-13.537-0.935-19.454,2.749c-3.401,2.117-5.209,5.742-6.633,9.544c-0.538,1.436-0.852,3.054-2.528,3.842c-0.674-0.763-0.122-1.555,0.036-2.263c0.343-1.538,0.903-3.027,1.179-4.575c0.633-3.541,1.934-6.569,4.364-9.275c3.808-4.241,4.486-9.393,2.797-14.961c-1.131-3.727-2.786-7.125-4.944-10.356c-6.938,8.244-11.949,14.359-3.509,29.101c-0.402,2.664-1.874,4.898-3.047,7.449c-0.565-5.504-0.948-11.093-5.268-14.983c-4.069-3.664-9.047-4.875-14.546-5.915c0.719,5.111,0.777,9.885,2.728,14.236c2.233,4.981,6.497,7.012,11.278,8.038c1.513,0.325,2.923,0.621,3.751,1.837c0.549,1.026,0.453,1.896,0.135,2.68c-2.896,7.136-7.179,13.226-12.966,19.173c0.198-6.946-2.665-11.557-7.554-15.26c-1.464,3.47-3.105,6.63-2.809,10.47c0.311,4.029,3.227,6.268,5.731,9.144c-4.307,6.425-10,11.231-14.936,17.545c-1.597-5.813-2.214-11.342-4.022-16.517c-1.787-5.116-3.619-10.214-5.508-15.535c2.977-2.003,6.762-2.779,7.839-6.837c0.685-2.578,1.256-5.16,0.464-8.112c-3.475,0.321-5.885,2.374-8.174,5.144c-0.845-2.284-0.006-4.371-0.437-6.257c-1.145-0.444-1.295,0.481-1.527,1.079c-2.393,6.169-3.065,12.436-1.005,18.892c0.802,2.514,1.767,4.993,2.217,8.207c-2.602-2.18-5.061-3.78-8.013-4.093c-2.874-0.304-5.738-0.295-8.645,0.734c1.096,4.161,2.976,7.738,5.77,10.728c2.682,2.87,6.064,3.294,9.623,2.605c1.515-0.293,2.953-0.682,4.576,1.123c2.078,10.323,0.263,20.675-3.033,31.414c-4.983-8.303-10.251-15.599-20.292-15.821c-1.756,5.286,0.019,9.642,6.054,14.635c-5.427,3.231-7.701,8.319-7.89,14.837c8.249,1.044,14.23-1.784,16.976-11.257c0.999,2.017,1.109,3.411,1.195,4.796c0.549,8.876-2.525,16.305-8.606,22.195c-8.576,8.307-18.79,12.485-30.488,12.37c-1.993-0.02-3.897-0.376-5.82-2.5c0.144-13.911,2.975-27.893,4.978-42.19c7.789,5.303,11.648,5.55,16.123,1.136c-0.98-3.504-3.161-5.716-6.285-6.487c0.898-1.099,1.845-2.295,2.831-3.456c1.004-1.182,2.089-2.304,2.01-4.518c-3.273-0.833-6.567-0.841-10.497,0.83c2.172-5.188,4.752-9.283,7.582-13.197c2.026-2.802,4.201-5.469,6.087-8.402c4.591-7.141,6.8-15.111,7.645-23.567c0.375-3.752,0.431-7.538,0.697-11.304c0.426-6.038,1.956-11.73,4.968-16.923c0.772-1.331,1.642-2.574,3.653-3.085c1.332,4.908,3.607,8.876,8.249,10.592c4.082,1.509,8.125,0.782,12.522-0.256c-2.248-5.475-4.293-10.721-10.058-12.863c-2.704-1.005-5.423-0.754-8.181-0.44c-1.554,0.177-1.839,1.914-3.085,2.474c1.447-3.152,3.351-5.913,6.005-7.995c1.523-1.195,3.13-1.044,4.77,0.262c1.194,0.951,2.233,2.131,3.468,3.011c3.767,2.686,7.707,3.523,12.05,1.353c3.249-1.623,6.196-3.632,9.046-6.12c-3.708-4.658-8.288-6.78-13.698-7.064c-3.173-0.166-5.791,1.311-8.215,3.281c-1.356,1.101-2.661,2.299-4.629,2.444c-0.405-1,0.187-1.694,0.657-2.243c1.234-1.441,2.587-2.768,3.879-4.154c1.713-1.838,3.679-2.51,6.201-2.424c6.854,0.235,10.665-2.875,12.658-9.889c0.524-1.844,0.938-3.724,1.404-5.595c-8.123-1.628-13.78,0.82-18.046,7.625c1.222-7.334-0.573-13.639-5.66-19.344c-3.775,4.481-7.026,8.945-7.895,14.824c-0.405,2.737,0.448,5.301,1.739,7.68c0.516,0.951,1.052,1.889,1.582,2.831c1.974,3.509,1.693,5.499-1.184,8.3c-0.507,0.493-1.023,0.978-1.568,1.422c-0.151,0.123-0.419,0.086-0.861,0.161c0.302-5.241-1.588-9.637-4.759-13.91c-2.485,2.904-4.581,5.689-5.101,9.486c-0.553,4.031,1.635,6.933,3.528,9.586c0.456,1.97-0.429,3.117-1.219,4.329c-1.764,2.705-3.562,5.377-4.939,8.353c-1.32,2.854-2.084,5.896-3.005,8.898c-1.148-0.033-1.519-1.094-2.075-1.777c-2.253-2.768-4.545-5.519-6.575-8.468c-3.542-5.146-5.33-11.001-5.626-17.356c-0.034-0.726,0.017-1.462,0.101-2.184c0.04-0.342,0.251-0.661,0.519-1.321c3.663,0.059,7.73,1.897,11.047-1.415c2.302-2.299,3.893-5.066,4.811-8.326c-2.501-1.769-5.414-0.932-8.21-1.75c1.949-3.789,4.53-7.155,5.438-11.376c0.127-0.59,0.246-1.196-0.143-1.81c-1.729-0.168-2.213,1.845-3.758,2.683c-0.123-5.267-2.337-9.235-5.331-13.149h-1.798c-2.811,3.536-4.89,7.065-5.124,11.599c-0.138,2.664,0.517,5.156,2.136,7.145c2.239,2.75,1.865,5.209-0.091,7.845c-1.349,1.817-2.505,3.793-3.789,5.666c-1.749,2.552-3.632,5.005-4.951,8.045c-2.836-1.871-4.222-4.626-5.279-7.573c-0.474-1.321-0.118-2.663,0.895-3.688c0.582-0.588,1.173-1.179,1.823-1.676c4.013-3.068,4.707-7.24,3.621-12.012c-0.428-1.882-0.815-3.783-1.872-5.808c-3.356,1.818-6.183,4.108-8.453,7.751c-0.302-1.936,0.23-3.299,1.004-4.359C83.603,8.526,83.836,4.234,82.497,0H71.824c-0.397,1.246-0.688,2.548-0.823,3.933c-0.269,2.763,0.356,5.322,1.784,7.653c1.723,2.813,2.638,5.876,3.027,9.22c0.293,2.516,1.103,4.962,1.646,7.449c0.223,1.021,0.889,1.987,0.386,3.323c-1.958-0.847-3.627-2.117-5.338-3.298c-3.151-2.174-4.889-5.019-4.17-9.223c0.55-3.209-0.541-5.943-2.553-8.385c-2.134-2.591-4.503-4.802-7.661-6.504c-2.609,5.917-2.293,11.38,1.135,16.977c-4.487-0.018-8.022,1.303-11.011,4.663c2.091,2.472,4.393,4.42,7.101,5.733c4.028,1.952,7.128,0.995,10.695-3.131c1.57,0.599,2.388,2.105,3.772,3.443c-3.275,1.396-6.263,2.769-8.748,5.654c2.952,3.553,6.205,6.341,10.917,5.592c2.917-0.464,5.496-1.899,5.972-5.757c1.318,0.395,2.056,1.508,2.763,2.503c5.539,7.794,11.717,15.03,17.566,22.552c2.957,3.803,5.204,8.019,7.2,12.415c2.326,5.122,1.516,10.144-0.376,15.19c-3.737,9.965-9.597,18.538-15.614,27.021c-1.451,2.045-2.915,4.08-4.333,6.15c-0.825,1.203-1.624,2.391-3.491,2.525c-2.251-0.831-4.016-2.616-5.412-4.885c0.501-2.606,2.746-4.057,3.125-6.573c0.359-2.381,1.059-4.704,1.645-7.203c5.877-1.203,10.593-3.967,12.641-10.444c-2.028-1.918-4.396-2.726-6.722-3.186c-0.55-1.298,0.149-1.843,0.819-2.294c1.261-0.849,2.623-1.536,3.858-2.421c4.804-3.443,6.244-9.314,3.697-15.23c-2.959-0.068-5.338,1.639-7.864,3.28c-1.042-1.683-0.181-3.75-1.179-5.217c-1.338-0.6-1.243,1.162-2.085,1.28c-2.066-2.428-3.302-5.54-5.668-7.667c-4.526,3.462-5.691,9.836-3.098,17.155c-2.117-0.886-3.442-2.964-6.021-3.166c-3.322,5.237-2.196,10.338,1.085,15.625c-3.682,0.863-7.162,1.853-7.766,6.182c-0.483,3.465-0.663,7.018,1.91,9.997c2.955-1.113,4.965-3.284,7.009-5.47c2.186,5.141,0.517,9.976-4.107,11.324c-4.954,1.444-9.012,4.18-12.146,8.076c-0.962,0.17-1.368-0.306-1.724-0.76c-5.067-6.467-10.688-12.451-15.175-19.424c-2.088-3.245-3.702-6.715-4.58-10.549c-0.328-1.432-0.543-2.854-0.108-4.524c4.387-1.726,12.176-5.068,13.734-10.505c1.158-4.043-0.328-7.589-1.353-11.593c-4.159,1.306-10.415,5.07-12.557,9.247c-0.441-2.117-0.146-3.531,0.392-4.954c0.898-2.374,1.752-4.766,2.628-7.149c1.286-3.499,1.34-7.103,0.924-10.904c-3.377,0.371-5.811,2.3-8.25,5.072c-0.656-2.709-2.815-1.771-4.512-2.627c2.437-2.485,4.578-4.956,4.6-8.712c0.026-4.349-0.924-8.358-2.955-12.351c-5.584,4.102-8.815,9.222-8.841,16.287c-0.004,0.975-0.056,1.957,0.037,2.922c0.203,2.111-0.579,3.81-1.889,5.28c-2.69,3.017-6.276,4.748-9.688,8.152v-14.04c4.401-0.847,8.317-2.675,10.241-7.433c1.604-3.967,1.135-7.804-0.793-11.801c-2.839,0.849-5.074,2.623-7.235,4.798c-0.166-1.34,0.835-2.542-0.263-3.778c-3.031,1.41-4.824,4.91-5.666,7.938c-1.437,5.172-1.212,9.944-1.344,15.317c-0.021,0.847-0.003,1.695-0.003,3.227c-0.363-0.415-0.696-0.834-1.009-1.256v18.752c0.07,0.588,0.146,1.172,0.196,1.769c0.477,5.794,2.698,11.037,5.259,16.117c2.436,4.831,5.132,9.522,7.089,14.61c0.382,0.994,0.86,1.985,0.827,2.651c-0.179,0.784-0.341,0.826-0.624,0.656c-4.227-2.527-8.53-4.928-12.746-7.473v12.862c1.416,1.122,2.818,2.267,4.242,3.374c0.356,0.276,0.761,0.573,0.614,1.399c-1.363,0.841-3.061,1.009-4.695,1.424c-0.055,0.014-0.106,0.032-0.161,0.046v14.446c2.785-1.589,5.357-4.45,7.76-8.641c0.154,4.74,1.061,8.703,4.398,11.513c2.456-2.446,2.753-3.582,2.909-10.811c0.654-0.48,1.075-0.009,1.411,0.463c5.454,7.674,9.9,15.915,11.343,25.514c1.073,7.14,0.704,14.367-0.768,21.429c-1.779,8.54-0.939,16.944,0.526,25.372c1.689,9.719,4.522,19.035,7.793,28.308c3.259,9.241,4.96,19.005,4.312,29.022c-0.172,2.657-0.457,5.298-1.709,7.686c-1.745,0.063-2.593-1.221-3.359-2.362c-4.935-7.357-8.143-16.943-12.428-23.489l-2.941-4.793c-1.475-7.101-3.744-13.887-8.027-19.978c-0.427-0.608-0.7-1.279-0.723-2.177c0.25-1.538,1.353-2.396,2.764-3.121c7.553-3.88,10.083-8.848,8.952-17.539c-0.415-3.191-0.816-6.399-2.128-9.897c-4.936,2.915-9.401,5.928-12.16,10.97c-2.846,5.201-1.81,10.763-0.263,16.604c-1.997-1.258-5.657-5.187-7.663-7.934v20.877c2.878,3.067,6.192,6.595,6.709,8.946c0.75,3.411-0.392,7.155,0.235,10.588c0.104,0.566,0.23,1.126,0.352,1.687c1.766,4.666,2.236,7.725,5.293,11.112c0.236,0.204,0.468,0.414,0.708,0.613c8.692,7.215,4.663,20.794,9.826,30.959c2.686,5.288,4.058,11.103,5.11,16.969c1.525,8.503,2.648,17.056,2.508,25.751c-0.047,2.941-0.463,5.823-0.887,8.707c-0.193,1.309-0.489,2.656-1.664,3.433c-1.707,0.853-3.139-0.298-4.617-0.872c-1.367-0.531-2.649-1.257-3.908-2.011c-6.188-3.708-12.86-5.956-19.666-7.697v16.056c1.213,0.142,2.439,0.358,3.68,0.656c7.953,1.911,14.662,6.265,19.61,13.355c2.912,4.172,4.259,8.958,4.582,13.969c0.43,6.687,0.156,13.392-1.092,20.008c-0.296,1.568-0.67,3.087-1.723,4.354c-2.45,1.186-4.523-0.086-6.409-1.434c-3.433-2.452-6.759-5.077-10.061-7.727c-2.764-2.218-5.638-4.205-8.588-6.035v24.5c1.314,1.273,2.615,2.575,3.888,3.937c8.681,9.293,20.775,19.688,27.527,30.654c3.227,5.24,8.613,20.231,12,25.412c12,18.353,23.942,28.935,31.765,45.176c3.958,9.514,16.509,29.947,12.385,39.082c-1.173,2.599-2.903,4.593-5.16,6.226c-9.164,6.632-19.467,9.702-30.322,11.245c-7.286,1.036-14.628,1.813-21.685,4.21c-4.851,1.648-9.377,3.998-13.685,6.859c-2.921,1.94-5.865,3.849-8.851,5.674c-2.51,1.534-5.14,2.609-7.862,3.325v14.605c3.183-0.466,6.516-0.441,9.946,0.126c2.707,0.447,5.435,0.77,8.244,1.905c-1.682,2-3.706,3.168-5.617,4.433c-3.68,2.435-5.973,5.984-7.708,10.048c-0.287,0.672-0.467,1.334-0.487,2.005l0,0c0.105,0.106,0.22,0.2,0.329,0.302c0.176,0.166,0.353,0.33,0.537,0.488c0.276,0.232,0.56,0.455,0.85,0.67c5.815-7.589,13.711-11.337,22.231-14.071c6.223-1.997,12.521-1.657,18.832-0.963c9.221,1.014,18.403,0.735,27.573-0.586c0.798-0.115,1.597-0.231,2.4-0.28c0.321-0.019,0.652,0.142,1.095,0.25c-0.271,3.041-2.289,4.768-4.329,6.268c-2.544,1.871-5.215,3.609-7.998,5.045c-5.263,2.716-10.629,5.134-16.087,7.286h44.941c0.001-0.021,0.006-0.042,0.008-0.062c0.586-9.271,5.533-16.08,11.305-22.359c2.646-2.878,5.732-5.269,9.006-7.353c5.874-3.739,10.927-8.515,15.47-13.904c0.916-1.087,1.884-2.064,3.154-3.167c3.514,6.92,3.816,13.826,1.331,20.881c-2.576,7.315-6.851,13.461-12.1,18.881c-2.485,2.566-5.088,4.915-7.79,7.084h25.083c1.573-5.058,4.037-9.648,7.958-13.612c6.76-6.835,10.813-15.342,12.015-25.28c0.287-2.373,0.664-4.784,1.588-6.904c0.428-0.075,0.728-0.229,0.844-0.134c4.217,3.48,7.749,7.643,10.317,12.587c2.356,4.535,1.767,9.181-0.404,13.652c-1.795,3.696-4.146,7.003-6.485,10.328c-2.131,3.029-4.33,6.043-5.98,9.363h21.791c-0.439-0.742-0.872-1.489-1.276-2.257c-1.874-3.569-1.941-6.966,0.07-10.354c1.574-2.651,2.911-5.436,4.125-8.414c7.962,5.704,13.886,12.639,17.669,21.026h26.307c-11.057-6.578-21.203-14.512-29.736-24.763c-5.532-6.646-9.386-14.412-12.752-22.459c-0.123-0.294-0.045-0.681-0.09-1.638c1.679,1.288,3.079,2.258,4.369,3.37c5.908,5.091,12.199,9.542,18.929,13.353c6.723,3.807,12.843,8.522,18.362,14.152c4.038,4.12,7.489,8.694,9.757,14.044c0.662,1.562,1.498,2.848,2.474,3.943h7.063c-0.441-1.909-0.875-3.809-0.584-5.842c4.355,1.39,8.168,3.677,12.181,5.449c0.28,0.124,0.547,0.266,0.825,0.393h19.82c-12.992-5.065-25.375-11.492-36.749-20.144c-0.734-0.558-1.586-0.99-2.092-2.248c1.217-0.546,2.398-0.205,3.537,0.044c5.998,1.311,12.02,2.291,18.155,1.278c7.553-1.247,14.328,1.448,20.965,4.657c6.592,3.187,13.018,6.72,19.2,11.865c-0.186-2.161-1.3-3.014-2.229-3.919c-3.57-3.483-7.529-6.419-11.722-8.994c-2.486-1.527-5.056-2.9-7.566-4.384c-0.654-0.387-1.567-0.486-1.822-1.637c3.913-2.566,8.027-2.319,12.182-0.934c7.515,2.505,14.547,6.109,21.002,10.879c4.795,3.544,13.855,9.693,20.267,13.537h10.164c-5.57-3.131-10.878-8.221-15.49-11.8c-6.754-5.241-15.155-11.373-22.588-15.882l-14.118-7.647c-6.049-2.164-13.232-3.142-17.653-5.112c-5.519-2.46-10.753-5.541-16.05-8.474c-8.416-4.66-17.171-8.097-26.653-9.552c-6.655-1.021-41.787-21.987-47.682-25.328c-12.352-7.001-23.485-15.848-33.795-25.825c-20.981-26.022-47.075-52.208-56.647-84.989c-1.974-9.419-1.19-18.436,2.947-26.997c2.528-5.232,6.091-9.724,10.118-13.785c5.203-5.247,11.018-9.641,17.368-13.138c12.154-6.694,24.496-6.61,36.826-0.434c2.844,1.425,5.326,3.491,7.279,6.069c2.588,3.416,5.061,6.951,7.32,10.617c2.571,4.172,2.105,7.016-1.569,10.101c-4.062,3.412-5.332,7.879-4.524,13.007c0.741,4.698,2.576,9.03,4.894,13.167c8.424-7.673,10.628-15.947,6.278-24.484c-0.626-1.228-1.241-2.595-0.457-4.02c1.067-0.116,1.239,0.699,1.541,1.291c0.93,1.822,1.739,3.717,2.745,5.489c1.477,2.604,2.014,5.216,1.521,8.327c-1.194,7.545,1.611,13.538,7.052,18.355c2.753,2.438,5.811,4.252,9.351,5.911c1.099-7.132,1.12-13.82-1.755-20.225c-1.494-3.328-3.969-5.75-7.159-7.078c-4.627-1.927-6.353-5.902-7.598-10.966c3.923,1.209,7.541,1.98,9.85,5.69c1.255,2.016,2.742,3.891,4.745,5.243c4.297,2.9,8.975,2.831,13.688,1.925c3.735-0.718,7.296-2.161,11.173-3.8c-3.316-5.727-7.76-9.809-13.516-12.437c-6.368-2.907-11.891-0.047-17.334,2.812c-5.543-1.505-9.328-5.191-13.093-9.632c2.325-0.33,3.793,0.609,5.24,1.552c5.714,3.722,11.354,3.291,16.913-0.347c2.345-1.535,4.59-3.229,6.544-5.311c-5.187-6.372-16.383-10.671-25.439,0.381c-3.547,1.163-5.937-1.851-8.5-4.797c-1.265-1.455-2.433-2.99-3.575-4.544c-4.134-5.623-9.38-9.598-15.377-12.606c-0.586-0.294-1.325-0.417-1.748-1.378c1.726-1.191,3.711-1.671,5.674-2.152c14.588-3.58,29.069-2.696,43.324,1.741c12.237,3.808,24.444,7.78,35.814,14.121c3.779,2.107,7.495,4.274,10.855,7.074c2.611,2.175,2.932,3.877,1.179,6.904c-1.198,2.07-2.575,3.993-3.316,6.363c-1.393,4.452-0.952,8.72,1.151,12.698c1.959,3.706,4.276,7.201,6.66,11.161c3.669-5.173,6.556-10.319,7.221-16.53c0.716-6.693-3.098-11.419-7.362-16.761c3.237,0.87,5.848,1.935,8.074,3.425l0.085,0.09c4.118,4.856,8.947,8.834,13.429,13.235c1.165,1.144,2.218,2.419,3.493,3.442c1.002,0.804,2.079,1.479,3.276,1.924c7.27,2.7,13.69-0.139,20.27-3.603c-2.529-2.642-4.716-5.103-7.08-7.358c-4.232-4.035-9.083-5.333-14.67-2.996c-1.397,0.584-2.852,1.076-4.319,1.379c-2.579,0.533-4.053-0.224-5.42-2.704c6.863-1.325,10.7-5.69,11.887-12.976c-6.787-0.892-12.49,0.181-15.853,7.675c-2.677-3.127-5.853-5.015-9.237-6.375l-6.698-5.1c-3.529-4.412-3.196-7.983-4.214-9.245c0.406-0.77,0.989-0.852,1.544-1.005c4.236-1.168,8.363-2.68,12.351-4.58c4.348-2.071,8.859-3.295,13.625-3.68c5.511-0.446,10.953-1.313,15.833-5.157c1.844,8.005,7.23,10.164,14.061,10.607c0.251-7.378-2.666-12.405-9.141-15.037c1.823-2.168,3.416-2.624,5.842-1.6c1.38,0.582,2.712,1.347,3.969,2.192c5.026,3.377,10.037,3.046,14.972-0.091c2.757-1.753,5.38-3.742,8.374-5.843c-5.783-4.676-11.529-8.707-19.185-7.47c-1.26,0.204-2.448,0.656-3.587,1.251c-1.45,0.756-2.73,1.802-4.095,2.698c-5.251,3.447-10.761,6.412-15.743,10.376c-2.872,2.285-7.042,2.262-11.239,1.139c1.062-3.62,3.006-6.757,4.79-9.921c4.457-7.905,10.877-13.076,19.506-14.995c3.141-0.698,6.269-1.463,9.386-2.271c5.138-1.333,8.187-4.64,8.733-10.361c0.243-2.541,0.557-5.06,0.035-7.517c-0.307-0.184-0.538-0.442-0.694-0.399c-4.179,1.17-7.902,3.253-11.003,6.453c-1.547,1.596-1.898,3.846-2.531,5.923c-0.781,2.562-2.281,4.332-5.349,5.356c1.776-4.411,2.898-8.434,3.928-12.492c0.254-1.001,0.966-1.948,1.655-2.736c3.494-3.993,3.855-8.717,2.714-13.649c-0.742-3.208-2.343-6.049-4.669-8.672c-4.392,4.712-7.508,9.842-6.598,17.357c-3.084-2.501-5.388-4.915-8.495-5.969c-3.436,8.62-4.621,16.614,5.729,23.881c-0.562,1.851-2.031,2.772-3.488,3.704c-2.56,1.638-5.148,3.219-7.472,5.249c-2.42,2.113-4.541,4.482-6.278,7.245c-0.892,1.42-1.841,2.8-2.738,4.216c-6.661,10.514-16.378,15.062-27.836,16.118c-8.504,0.784-17.046-0.703-25.008-3.791c-3.519-1.365-7.072-2.642-10.583-3.943c-0.008-1.614,1.283-1.875,2.112-2.536c1.584-1.261,3.193-2.48,4.947-3.491c6.722-3.876,10.55-10.116,13.485-17.122c0.884-2.11,1.839-4.199,2.917-6.204c2.515-4.681,4.846-5.198,9.609-1.974c-0.34,5.368-0.618,11.018,3.768,15.343c3.517,3.468,7.825,4.934,12.396,5.84c1.991-7.188-1.032-16.654-6.429-20.499c-1.474-1.051-3.094-1.544-4.779-1.968c-2.314-0.582-4.292-1.662-5.167-4.243c3.444-3.9,8-6.256,11.247-10.133c1.852-0.647,3.712-0.673,5.538-0.826c5.789-0.486,9.986-3.471,12.58-8.897c1.865-3.9,2.872-8.135,4.252-12.098c-1.362-1.278-2.492-0.496-3.57-0.446c-2.77,0.126-5.462,0.736-8.138,1.484c-6.49,1.815-10.544,6.152-12.224,13.007c-0.605,2.47-1.097,4.978-2.734,7.017c-1.108,1.381-2.307,2.572-4.157,3.035c1.029-2.788,3.096-4.938,3.943-7.791c0.914-3.081,0.565-6.041-0.474-8.936c-1.013-2.821-2.021-5.677-3.942-8.012c-7.324,5.36-9.08,13.036-5.005,21.269c0.775,1.566,2.056,3.051,1.284,5.184c-0.802,1.187-2.214,1.514-3.428,2.15c-5.747,3.01-10.316,7.157-12.847,13.635c-2.814,7.202-7.844,12.098-14.628,15.202c-9.618,4.4-19.43,5.92-29.961,4.782c-12.566-1.357-25.22-0.255-37.467,3.99c-1.254,0.435-2.565,0.646-3.87,0.885c-0.849,0.155-1.665,0.788-2.554,0.151c-0.688-0.931-0.25-1.84,0.07-2.735c1.59-4.449,2.97-8.955,3.497-13.707c0.212-1.91,1.048-3.425,2.787-4.767c11.338,5.202,18.64-1.201,25.154-10.213c-1.077-1.648-2.781-1.871-4.202-2.383c-3.393-1.222-6.872-1.858-10.508-1.054c-4.077,0.901-7.166,3.165-9.332,6.887c-1.008,1.732-1.877,3.58-3.566,4.915c-0.394-2.915,1.082-9.257,2.474-11.016c0.539-0.681,1.281-1.004,2.006-1.378c1.343-0.694,2.698-1.371,4.001-2.142c3.957-2.339,6.474-5.854,7.164-10.604c0.643-4.436,0.459-8.899,0.116-13.558c-2.192,0.093-3.475,1.419-4.949,2.221c-2.363,1.285-4.479,2.979-6.602,4.654c-2.827,2.23-4.443,5.229-4.885,8.897c-0.188,1.563-0.431,3.218-0.151,4.727c0.899,4.847-1.76,8.255-4.198,12.828c-1.499-6.644-2.659-12.718-8.859-15.319c-4.205-1.764-9.803-2.668-12.655-1.817c1.774,13.426,6.414,18.191,17.925,18.47c2.422,2.524,2.638,3.226,1.944,7.096c-1.854-1.896-3.264-4.088-5.637-4.835c-2.199-0.692-4.399-1.438-6.744-0.868c0.057,6.413,3.501,9.985,11.371,11.701c-0.341,3.632-1.977,6.635-4.201,9.269c-2.381,2.82-5.027,5.371-8.097,7.36c-4.12,2.669-8.164,5.474-12.514,7.73c-3.939,2.043-7.594,4.589-11.196,7.22c-3.51,2.564-7.169,4.862-10.949,6.948c-2.504,1.382-3.259,1.535-6.008,1.222c-1.583-1.733-1.814-4.119-2.075-6.349c-2.034-17.398,0.448-33.871,8.646-49.352c7.322-13.826,17.441-24.676,29.819-33.397c8.174-5.76,17.317-8.992,26.662-11.651c5.764-1.64,11.629-2.908,17.482-4.168c3.207-0.691,6.443-0.22,9.554,0.781c6.377,2.054,12.728,4.199,19.081,6.337c1.653,0.556,3.173,1.428,4.616,2.447c1.255,0.886,1.995,2.003,1.557,3.748c-0.831,1.478-2.246,2.354-3.563,3.306c-4.702,3.399-6.199,8.286-5.77,13.991c0.255,3.397,1,6.718,2.086,10.388c4.972-2.293,9.035-5.365,11.269-10.641c2.265-5.348,0.773-10.663-0.378-16.016c2.725,2.886,5.236,5.509,4.619,10.243c-0.914,7.01,2.369,12.175,7.833,15.878c2.228,1.51,4.635,2.678,7.085,3.719c4.307-9.221,0.312-20.743-8.43-24.578c-3.828-1.679-6.138-4.119-7.741-8.184c0.479-0.728,1.013-0.656,1.497-0.392c1.004,0.548,1.885,1.301,2.698,2.106c4.718,4.674,10.026,6.774,16.173,4.903c4.133-1.258,7.677-3.626,11.367-6.698c-4.558-3.751-8.736-7.237-14.242-8.411c-6.018-1.283-10.294,2.509-14.796,5.6c-1.899-0.296-3.718-0.475-5.391-1.998c1.508-1.142,3.23-1.373,4.774-1.967c3.848-1.48,7.253-3.618,10.183-6.677c2.67-2.787,5.931-4.525,9.536-5.651c1.656-0.518,3.124-0.43,4.685,0.254c2.039,0.893,3.847,2.186,5.721,3.376c4.627,2.937,9.595,4.661,15.049,4.561c0.548-0.01,1.156,0.081,1.669-0.709c-0.197-1.788-1.554-1.88-2.944-2.068c-4.706-0.635-8.828-2.628-12.281-6.098c-0.32-0.321-0.747-0.59-0.674-1.384c4.06-2.769,9.25-1.276,13.616-3.119c-0.171-1.396-0.86-1.705-1.72-1.771c-0.459-0.035-0.922-0.052-1.381-0.032c-6.215,0.272-12.44,0.407-18.642,0.875c-5.303,0.401-9.993,2.667-14.146,6.179c-3.429,2.9-7.136,5.221-11.771,6.089c3.388-4.112,2.697-8.524,1.322-13.201c-2.911,0.983-4.844,3.158-6.669,5.496c-2.002,2.564-1.371,5.797-1.959,9.001c-6.534-0.536-12.135-3.472-18.181-6.682c3.418-2.523,6.486-4.868,9.594-7.084c3.936-2.806,7.756-5.773,11.421-8.924c6.813-5.857,14.207-10.328,22.982-11.758c13.461-2.194,25.596,1.154,36.452,9.681c3.149,2.474,6.383,4.793,9.661,7.048c5.596,3.849,11.99,4.845,18.453,5.261c4.365,0.281,8.755,0.109,13.134,0.137c1.508,0.009,3.039-0.061,4.159,1.735c0.581,3.344-0.929,7.444,2.209,10.444c2.333,2.23,4.938,3.853,8.216,4.669c0.745-3.295,0.938-6.378,0.242-9.525c-0.47-2.126-1.435-3.904-3.234-4.963c-3.299-1.941-6.379-4.343-10.657-5.659c3.177-1.676,5.794-3.469,8.331-5.476c2.089,0.784,3.643,2.281,5.371,3.425c3.607,2.389,6.985,1.855,10.316-0.549c2.107-1.52,3.803-3.5,5.797-5.521c-3.695-2.866-7.76-3.65-12.182-3.902c7.155-6.248,8.695-10.85,5.688-16.851c-2.358,0.164-3.926,2.343-6.145,2.945c-1.133-0.034-0.573-1.515-2.069-1.909c-3.263,0.771-5.828,3.229-7.229,7.129c-1.343,3.74-1.011,7.652-0.767,11.472c-2.419,2.325-5.086,3.59-8.237,4.364c8.146-6.375,6.401-14.317,3.449-22.984c-3.942,2.554-7.116,5.54-9.163,9.735c-2.178,4.464,0.29,8.761,0.748,12.856c-1.179,2.23-2.832,2.756-4.782,2.896c-7.223,0.518-13.679-1.882-19.494-6.097c-4.647-3.369-8.604-7.667-12.671-11.608c0.135-1.058,0.848-1.045,1.317-1.129c8.576-1.536,16.572-4.949,24.552-8.417c7.016-3.049,13.9-6.447,21.283-8.483c7.931-2.187,15.915-2.402,23.97-1.029c0.564,0.096,1.134,0.199,1.675,0.385c0.315,0.108,0.578,0.387,1.172,0.806c0.031,4.144-1.327,8.897,2.403,12.435c2.647,2.511,5.847,3.67,9.681,4.544c0.923-6.175,0.004-11.43-5.078-16.047c5.496,0.369,9.785,1.574,12.515,6.381c0.71,1.25,0.771,2.516,0.692,3.858c-0.086,1.456-0.269,2.908-0.31,4.365c-0.13,4.575,1.551,8.303,4.898,11.165c2.678,2.29,5.56,4.208,9.41,5.245c0.472-5.806,1.281-11.271-1.53-16.509c-1.508-2.809-3.883-4.402-6.477-5.797c-1.912-1.028-3.764-2.147-4.65-4.704c2.287,0.063,3.998,0.866,5.455,2.325c0.753,0.754,1.436,1.591,2.223,2.299c4.509,4.054,9.476,5.861,15.327,3.523c3.11-1.242,6.294-2.288,9.368-4.308C379.283,230.519,375.735,227.188,371.132,225.27z M76.46,94.092c1.367-3.167,1.569-6.221,0.425-9.647c1.44,1.796,3.816,2.166,5.263,3.777c-0.37,4.686-3.258,11.717-5.58,13.571C75.387,99.215,75.395,96.559,76.46,94.092z M50.995,210.687c-2.049-0.472-3.09-1.786-3.849-3.557c-2.236-5.22-3.998-10.623-5.248-16.179c-0.807-3.586-0.58-7.272,0.499-10.827c0.94-3.097,2.069-3.765,5.596-3.275c-2.168,6.967,0.425,12.398,4.63,17.234c1.527-0.362,2.237-1.187,2.96-1.953c5.286-5.606,4.016-14.207-2.655-17.723c-2.16-1.139-4.412-2.093-6.838-2.446c-0.801-0.116-1.602-0.224-2.401-1.177c0.241-6.789-0.016-13.843,0.61-20.877c0.168-1.889,0.899-3.489,2.348-4.701c0.688-0.576,1.628-1.106,1.025-2.367c-1.408-1.155-3.188,0.642-4.77-0.776c-1.104-3.37-1.683-7.535-6.039-8.126c-1.749,0.643-2.436,2.322-3.917,2.736c-1.412-1.065-2.285-2.529-3.132-3.952c-5.762-9.676-11.394-19.437-16.294-29.642c-2.196-4.573-3.93-9.328-4.614-14.452c-0.194-1.45-0.486-2.895,0.772-4.455c4.568-1.427,6.258-0.698,9.039-4.839l1.647-2.941c-1.393-2.34-3.406-3.258-5.924-3.831c-1.379-0.314-2.909,0.136-4.223-0.747c0.509-1.623,1.516-2.623,2.589-3.516c1.087-0.905,2.278-1.678,3.778-1.121c3.531,1.31,6.919,1.259,10.281-1.705c0.037,3.138-0.517,5.731-0.001,8.204c-1.552,0.941-2.747-0.877-4.235-0.105c-0.498,1.205-1.359,2.377-1.188,3.932c0,0.001-0.001,0.001-0.001,0.002c-0.136,2.417-0.488,4.967,0.662,7.358c1.369,2.846,3.812,4.04,6.496,4.854c0.173,0.984,0.391,1.81,0.454,2.649c0.391,5.263,2.381,9.846,5.218,14.099c2.454,3.679,4.887,7.375,7.262,11.111c0.592,0.932,1.684,1.661,1.488,3.202c-3.852-0.802-7.646-1.538-11.526,0.473c1.678,2.971,2.999,5.71,5.527,7.696c3.656,2.873,7.647,1.756,11.934,1.251c-1.046,3.888-2.907,7.529-0.674,10.883c2.073,3.112,5.214,4.823,8.991,5.316c0.766-2.544,0.954-4.685,0.7-6.887c-0.139-1.208-0.3-2.419-0.343-3.634c-0.163-4.597,6.238-10.213,10.479-9.225c1.173,0.273,2.081,1.03,2.906,1.88c1.989,2.048,2.934,4.643,3.205,7.496c0.497,5.23,0.32,10.465-0.2,15.681c-0.955,9.584-3.022,18.95-5.312,28.249c-1.39,5.645-3.03,11.273-6.321,16.078c-2.026,2.958-3.939,5.989-5.883,9.003C55.021,207.336,53.412,209.563,50.995,210.687z M210.461,582.076c6,2.269,12.16,3.88,18.513,3.885c8.339,0.006,16.171,1.977,23.737,5.482c4.284,1.984,8.676,3.732,12.686,6.609c-5.038,1.583-10.05,2.975-15.258,2.579c-4.24-0.322-8.443-1.059-12.601-2.054c-10.45-2.502-20.15-6.698-28.535-13.923c-1.144-0.985-2.326-1.925-3.313-3.388C207.594,580.602,209.054,581.544,210.461,582.076z M93.002,583.686c2.592-0.972,5.25-1.746,8.348-2.765c-0.104,2.74-1.352,4.354-2.469,6.002c-3.206,4.73-7.777,7.515-12.715,9.685c-8.687,3.818-17.814,5.638-27.154,6.381c-10.63,0.846-21.148-0.628-31.68-1.763c-1.619-0.174-3.226-0.468-5.43-0.794c6.552-4.711,13.21-7.364,19.94-9.829c2.169-0.794,4.415-1.316,6.714-1.64c7.321-1.031,14.679-1.269,22.048-1.469C78.222,587.287,85.75,586.406,93.002,583.686z";
  const TREE_PATH_BIRD   = "M223.072,508.762c-0.314-0.87-0.919-1.517-1.627-2.072c-2.993-2.35-6.408-3.563-10.197-3.749c-2.915-0.143-5.747,0.372-8.552,1.096c-0.848,0.219-1.696,0.434-2.582,0.661c0.151-1.218-0.087-1.456-1.291-1.406c0.282-1.847,0.621-3.685,0.832-5.537c0.533-4.679-0.167-9.121-2.733-13.163c-0.809-1.274-1.678-2.505-2.953-3.367c-1.599-1.08-3.268-0.629-3.897,1.113c-1.136,3.144-2.258,6.295-3.296,9.472c-0.882,2.7-0.392,5.212,1.361,7.462c0.236,0.304,0.472,0.608,0.734,0.944c-0.421,0.035-0.679-0.223-0.98-0.349c-2.665-1.112-5.642-0.444-7.398,1.811c-1.532,1.967-1.883,4.207-0.833,6.497c1.031,2.247,2.96,3.166,5.374,3.178c1.151,0.006,2.26-0.206,3.327-0.63c1.71-0.68,3.413-1.378,5.125-2.056c0.201-0.08,0.401-0.286,0.724-0.106c-0.234,0.252-0.718,0.615-0.951,0.803c-1.073,0.867-0.51,0.215-1.385,1.203c-0.336,0.38-0.543,1.128-0.032,1.605c0.557,0.52,1.276,0.216,1.661-0.166c0.501-0.497-0.294,0.314,0.204-0.186c0.625-0.627,0.88-1.613,1.758-2.266c-0.256,0.84-0.461,1.481-0.647,2.128c-0.501,1.739-1.074,3.462-1.473,5.224c-0.767,3.39,0.864,6.484,3.814,7.302c2.58,0.716,4.827,0.052,6.566-1.977c1.764-2.057,1.854-4.382,0.811-6.813c-0.14-0.326-0.444-0.582-0.45-1.053c0.447,0.292,0.836,0.564,1.241,0.81c2.211,1.346,4.57,1.692,6.964,0.683c3.221-1.358,6.362-2.899,9.625-4.168C223.1,511.231,223.51,509.975,223.072,508.762z";
  const TREE_PATH_FLOWER = "M348.015,31.283c-0.911,0.163-1.65,0.649-2.318,1.253c-2.822,2.553-4.595,5.713-5.419,9.416c-0.634,2.849-0.606,5.727-0.366,8.614c0.073,0.872,0.141,1.745,0.215,2.656c-1.175-0.355-1.45-0.16-1.605,1.035c-1.773-0.59-3.527-1.236-5.317-1.757c-4.521-1.316-9.018-1.378-13.436,0.468c-1.392,0.582-2.753,1.23-3.818,2.341c-1.335,1.393-1.172,3.114,0.438,4.029c2.906,1.651,5.822,3.29,8.778,4.851c2.512,1.326,5.07,1.268,7.585-0.079c0.339-0.182,0.679-0.363,1.055-0.563c-0.037,0.421-0.335,0.632-0.51,0.907c-1.547,2.439-1.391,5.486,0.534,7.598c1.68,1.843,3.828,2.568,6.263,1.92c2.389-0.636,3.621-2.382,4.041-4.759c0.2-1.133,0.179-2.263-0.058-3.385c-0.381-1.801-0.781-3.597-1.159-5.398c-0.045-0.212-0.214-0.444,0.018-0.731c0.209,0.274,0.485,0.812,0.631,1.073c0.673,1.204,0.126,0.539,0.952,1.569c0.318,0.396,1.02,0.726,1.576,0.303c0.607-0.461,0.429-1.221,0.118-1.665c-0.405-0.578,0.259,0.343-0.149-0.233c-0.512-0.722-1.44-1.14-1.936-2.116c0.785,0.395,1.382,0.705,1.988,0.998c1.629,0.788,3.23,1.644,4.9,2.335c3.212,1.329,6.536,0.245,7.842-2.524c1.142-2.422,0.868-4.748-0.838-6.806c-1.729-2.086-4.005-2.568-6.578-1.951c-0.345,0.083-0.649,0.339-1.114,0.266c0.364-0.391,0.697-0.729,1.009-1.086c1.701-1.951,2.44-4.218,1.851-6.748c-0.794-3.404-1.781-6.76-2.48-10.191C350.453,31.673,349.284,31.056,348.015,31.283z";

  /* ────────────────────────────────────────────
     STATE
  ──────────────────────────────────────────── */
  let grid = new Map();
  let titleFont     = TITLE_FONTS[0];
  let crosswordFont = CROSSWORD_FONTS[0];
  let currentUnit   = 'in';   // 'in' | 'cm'
  let fontsReady    = false;
  let shuffleSeed   = 0;      // 0 = deterministic (initial); >0 = shuffled layout
  const glyphCache  = new Map();

  /* ────────────────────────────────────────────
     DOM
  ──────────────────────────────────────────── */
  const svgEl    = document.getElementById('boardSvg');
  const wordEl   = document.getElementById('wordInput');
  const nameEl   = document.getElementById('familyInput');
  const widthEl  = document.getElementById('widthInput');
  const dimHint  = document.getElementById('dimHint');
  const warnEl   = document.getElementById('warnNote');
  const warnTxt  = document.getElementById('warnText');
  const unitSeg  = document.getElementById('unitSeg');

  /* ────────────────────────────────────────────
     SVG HELPERS
  ──────────────────────────────────────────── */
  function mkEl(tag, attrs) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, String(v));
    return el;
  }
  function clr(el) { while (el.firstChild) el.removeChild(el.firstChild); }

  /* ────────────────────────────────────────────
     CONTOUR TRACING (shared)
  ──────────────────────────────────────────── */
  function extractContours(px, cols, rows, ss) {
    const em = new Map();
    function ae(ax, ay, bx, by) {
      const k = `${ax},${ay}`;
      if (!em.has(k)) em.set(k, []);
      em.get(k).push([bx, by]);
    }
    function p(c, r) { return px[r * cols + c] === 1; }
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        if (!p(col, row)) continue;
        if (row === 0 || !p(col, row - 1))       ae(col,     row,     col + 1, row);
        if (row === rows-1 || !p(col, row + 1))  ae(col + 1, row + 1, col,     row + 1);
        if (col === 0 || !p(col - 1, row))       ae(col,     row + 1, col,     row);
        if (col === cols-1 || !p(col + 1, row))  ae(col + 1, row,     col + 1, row + 1);
      }
    }
    const rings = [], used = new Set();
    for (const sk of em.keys()) {
      if (used.has(sk)) continue;
      const [sx, sy] = sk.split(',').map(Number);
      const ring = [[sx, sy]];
      let ck = sk, safe = 0;
      while (safe++ < 200000) {
        const nx = em.get(ck);
        if (!nx || !nx.length) break;
        const [ex, ey] = nx.pop();
        if (!nx.length) em.delete(ck);
        used.add(ck);
        const nk = `${ex},${ey}`;
        if (ex === sx && ey === sy) break;
        ring.push([ex, ey]);
        ck = nk;
      }
      if (ring.length >= 3) rings.push(ring.map(([x, y]) => [x / ss, y / ss]));
    }
    return rings;
  }
  function simplify(pts) {
    if (pts.length <= 3) return pts;
    const o = [pts[0]];
    for (let i = 1; i < pts.length - 1; i++) {
      const [ax, ay] = pts[i - 1], [bx, by] = pts[i], [cx, cy] = pts[i + 1];
      if (Math.abs((bx - ax) * (cy - ay) - (by - ay) * (cx - ax)) > 0.001) o.push(pts[i]);
    }
    o.push(pts[pts.length - 1]);
    return o;
  }
  function rings2path(rings) {
    let d = '';
    for (const r of rings) {
      const s = simplify(r);
      if (s.length < 3) continue;
      d += `M ${s[0][0].toFixed(2)},${s[0][1].toFixed(2)} `;
      for (let i = 1; i < s.length; i++) d += `L ${s[i][0].toFixed(2)},${s[i][1].toFixed(2)} `;
      d += 'Z ';
    }
    return d;
  }

  /* ────────────────────────────────────────────
     GLYPH TRACING (cached)
  ──────────────────────────────────────────── */
  const CANON_SIZE = 100;
  const GLYPH_OVER = 8;

  function traceGlyph(char, family, weight) {
    const key = `${char}_${family}_${weight}`;
    if (glyphCache.has(key)) return glyphCache.get(key);

    const OVER = GLYPH_OVER, PAD = 8;
    const measCv = document.createElement('canvas');
    const measCtx = measCv.getContext('2d');
    const fontString = `${weight} ${CANON_SIZE}px "${family}", cursive, serif`;
    measCtx.font = fontString;
    const m = measCtx.measureText(char);
    const textW = Math.max(m.width, 1);
    const ascent  = m.actualBoundingBoxAscent  || CANON_SIZE * 0.85;
    const descent = m.actualBoundingBoxDescent || CANON_SIZE * 0.20;

    const cvW = Math.ceil(textW + PAD * 2);
    const cvH = Math.ceil(ascent + descent + PAD * 2);
    const cv = document.createElement('canvas');
    cv.width  = cvW * OVER;
    cv.height = cvH * OVER;
    const ctx = cv.getContext('2d');
    ctx.scale(OVER, OVER);
    ctx.font = fontString;
    ctx.fillStyle = '#000';
    ctx.textBaseline = 'alphabetic';
    ctx.fillText(char, PAD, PAD + ascent);

    const img = ctx.getImageData(0, 0, cv.width, cv.height);
    const bits = new Uint8Array(cv.width * cv.height);
    for (let i = 0; i < bits.length; i++) bits[i] = img.data[i * 4 + 3] > 64 ? 1 : 0;

    const rings = extractContours(bits, cv.width, cv.height, OVER);
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const ring of rings) {
      for (const [x, y] of ring) {
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
    }
    let d = '', bbox = null;
    if (isFinite(minX)) {
      d = rings2path(rings);
      bbox = { minX, minY, maxX, maxY };
    }
    const result = { d, bbox, advance: textW };
    glyphCache.set(key, result);
    return result;
  }

  function addCharPath(parent, char, cx, cy, sizePx, fill) {
    const g = traceGlyph(char, crosswordFont.family, crosswordFont.weight);
    if (!g.d || !g.bbox) return;
    const scale = sizePx / CANON_SIZE;
    const gcx = (g.bbox.minX + g.bbox.maxX) / 2;
    const gcy = (g.bbox.minY + g.bbox.maxY) / 2;
    parent.appendChild(mkEl('path', {
      d: g.d,
      transform: `translate(${cx.toFixed(2)},${cy.toFixed(2)}) scale(${scale.toFixed(4)}) translate(${(-gcx).toFixed(2)},${(-gcy).toFixed(2)})`,
      fill
    }));
  }

  function addNumPath(parent, num, cx, cy, sizePx, fill) {
    const s = String(num);
    const scale = sizePx / CANON_SIZE;
    const glyphs = [];
    let totalAdv = 0;
    for (let i = 0; i < s.length; i++) {
      const g = traceGlyph(s[i], crosswordFont.family, crosswordFont.weight);
      glyphs.push(g);
      totalAdv += g.advance;
    }
    let penX = cx - totalAdv * scale;
    for (let i = 0; i < s.length; i++) {
      const g = glyphs[i];
      if (g.d && g.bbox) {
        const glyphCenterX = penX + (g.advance * scale) / 2;
        const gcx = (g.bbox.minX + g.bbox.maxX) / 2;
        const gcy = (g.bbox.minY + g.bbox.maxY) / 2;
        parent.appendChild(mkEl('path', {
          d: g.d,
          transform: `translate(${glyphCenterX.toFixed(2)},${cy.toFixed(2)}) scale(${scale.toFixed(4)}) translate(${(-gcx).toFixed(2)},${(-gcy).toFixed(2)})`,
          fill
        }));
      }
      penX += g.advance * scale;
    }
  }

  /* ────────────────────────────────────────────
     TITLE — traced path (for export only)
  ──────────────────────────────────────────── */
  function renderNameTraced(text, maxWidth, winL, winR, idealCX, baselineY) {
    const OVER = 32, PAD = 16;
    const family = titleFont.family, weight = titleFont.weight;
    const measCv = document.createElement('canvas');
    const measCtx = measCv.getContext('2d');
    let fs = 88;
    let fontStr = `${weight} ${fs}px "${family}", cursive`;
    measCtx.font = fontStr;
    while (fs >= 20 && measCtx.measureText(text).width > maxWidth) {
      fs -= 2;
      fontStr = `${weight} ${fs}px "${family}", cursive`;
      measCtx.font = fontStr;
    }
    const m = measCtx.measureText(text);
    const textW = m.width;
    const ascent  = m.actualBoundingBoxAscent  || fs * 0.85;
    const descent = m.actualBoundingBoxDescent || fs * 0.20;
    const cvW = Math.ceil(textW + PAD * 2);
    const cvH = Math.ceil(ascent + descent + PAD * 2);
    const cv  = document.createElement('canvas');
    cv.width  = cvW * OVER;
    cv.height = cvH * OVER;
    const ctx = cv.getContext('2d');
    ctx.scale(OVER, OVER);
    ctx.font = fontStr;
    ctx.fillStyle = '#000';
    ctx.textBaseline = 'alphabetic';
    const drawX = PAD, drawY = PAD + ascent;
    ctx.fillText(text, drawX, drawY);
    const W = cv.width, H = cv.height;
    const img = ctx.getImageData(0, 0, W, H);
    const bits = new Uint8Array(W * H);
    for (let i = 0; i < bits.length; i++) bits[i] = img.data[i * 4 + 3] > 64 ? 1 : 0;
    const rings = extractContours(bits, W, H, 1);

    const halfW = textW / 2;
    const clampedCX = Math.max(winL + halfW, Math.min(winR - halfW, idealCX));
    const svgX0 = clampedCX - halfW;
    const svgY0 = baselineY;
    const ox = drawX * OVER, oy = drawY * OVER;
    const T_TENSION = 0.35, STEP = OVER;

    function fitSplineRing(rawRing) {
      if (rawRing.length < OVER * 4) return '';
      const thin = [];
      for (let i = 0; i < rawRing.length; i += STEP) {
        const px = svgX0 + (rawRing[i][0] - ox) / OVER;
        const py = svgY0 + (rawRing[i][1] - oy) / OVER;
        thin.push([px, py]);
      }
      if (thin.length < 4) return '';
      const n = thin.length;
      let d = 'M' + thin[0][0].toFixed(2) + ',' + thin[0][1].toFixed(2);
      for (let i = 0; i < n; i++) {
        const p0 = thin[(i-1+n)%n], p1 = thin[i], p2 = thin[(i+1)%n], p3 = thin[(i+2)%n];
        const c1x = p1[0] + (p2[0] - p0[0]) * T_TENSION;
        const c1y = p1[1] + (p2[1] - p0[1]) * T_TENSION;
        const c2x = p2[0] - (p3[0] - p1[0]) * T_TENSION;
        const c2y = p2[1] - (p3[1] - p1[1]) * T_TENSION;
        d += 'C' + c1x.toFixed(2) + ',' + c1y.toFixed(2) + ','
                 + c2x.toFixed(2) + ',' + c2y.toFixed(2) + ','
                 + p2[0].toFixed(2) + ',' + p2[1].toFixed(2);
      }
      return d + 'Z';
    }
    let d = '';
    for (let ri = 0; ri < rings.length; ri++) d += fitSplineRing(rings[ri]);
    return d;
  }

  /* ────────────────────────────────────────────
     TILE SILHOUETTE (raster union)
  ──────────────────────────────────────────── */
  function paintRR(px, cols, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    const x0 = Math.floor(x), x1 = Math.ceil(x + w);
    const y0 = Math.floor(y), y1 = Math.ceil(y + h);
    for (let py = y0; py < y1; py++) {
      for (let pp = x0; pp < x1; pp++) {
        if (pp < 0 || py < 0 || pp >= cols) continue;
        const nx = Math.max(x + r, Math.min(x + w - r, pp + 0.5));
        const ny = Math.max(y + r, Math.min(y + h - r, py + 0.5));
        const dx = (pp + 0.5) - nx, dy = (py + 0.5) - ny;
        if (dx * dx + dy * dy <= r * r ||
            (pp + 0.5 >= x + r && pp + 0.5 <= x + w - r) ||
            (py + 0.5 >= y + r && py + 0.5 <= y + h - r)) {
          const idx = py * cols + pp;
          if (idx >= 0 && idx < px.length) px[idx] = 1;
        }
      }
    }
  }
  function computeTileSilhouettePath(sortedKeys, offX, offY, T, SC) {
    const rCols = Math.ceil(BW * SC) + 2, rRows = Math.ceil(BH * SC) + 2;
    const pixels = new Uint8Array(rCols * rRows);
    for (const k of sortedKeys) {
      const [x, y] = k.split(',').map(Number);
      paintRR(pixels, rCols, (offX + x * T) * SC, (offY + y * T) * SC, T * SC, T * SC, 7 * SC);
    }
    return rings2path(extractContours(pixels, rCols, rRows, SC));
  }

  /* ────────────────────────────────────────────
     INTERNAL SCORE LINES (for export layer 2)
     Only draws edges where an adjacent tile
     exists — the outer perimeter is already
     represented by the red cut path.
  ──────────────────────────────────────────── */
  function computeScoreLines(offX, offY, T) {
    const lines = [];
    for (const k of grid.keys()) {
      const [x, y] = k.split(',').map(Number);
      const rx = offX + x * T, ry = offY + y * T;
      if (grid.has(`${x+1},${y}`)) {
        lines.push({ x1: rx + T, y1: ry, x2: rx + T, y2: ry + T });
      }
      if (grid.has(`${x},${y+1}`)) {
        lines.push({ x1: rx, y1: ry + T, x2: rx + T, y2: ry + T });
      }
    }
    return lines;
  }

  /* ────────────────────────────────────────────
     GRID LAYOUT MATH (shared)
  ──────────────────────────────────────────── */
  function computeLayout(g) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const k of g.keys()) {
      const [x, y] = k.split(',').map(Number);
      if (x < minX) minX = x; if (y < minY) minY = y;
      if (x > maxX) maxX = x; if (y > maxY) maxY = y;
    }
    const cols = maxX - minX + 1, rows = maxY - minY + 1;
    const NAME_BASELINE = BH - 96;
    const availW = RW - RPAD * 2, availH = NAME_BASELINE - RPAD * 2;
    let T = Math.min(Math.floor(availW / cols), Math.floor(availH / rows));
    T = Math.max(T, 24);
    const gridW = cols * T, gridH = rows * T;
    let offX = RX + RPAD + (availW - gridW) / 2 - minX * T;
    const offY = RPAD + (availH - gridH) / 2 - minY * T;
    const rightEdge = offX + (maxX + 1) * T;
    const maxRight  = BW - 48;
    if (rightEdge > maxRight) offX -= (rightEdge - maxRight);
    const gridCX = offX + minX * T + cols * T / 2;
    return { minX, minY, maxX, maxY, cols, rows, T, offX, offY, NAME_BASELINE, gridCX };
  }

  /* ────────────────────────────────────────────
     CROSSWORD LAYOUT
  ──────────────────────────────────────────── */
  function canPlace(word, sx, sy, dx, dy, g) {
    const dir = dx === 1 ? 'h' : 'v';
    for (let i = 0; i < word.length; i++) {
      const x = sx + i * dx, y = sy + i * dy, k = `${x},${y}`;
      const ex = g.get(k);
      if (ex && ex.letter !== word[i]) return false;
      if (!ex) {
        if (dir === 'h' && (g.has(`${x},${y-1}`) || g.has(`${x},${y+1}`))) return false;
        if (dir === 'v' && (g.has(`${x-1},${y}`) || g.has(`${x+1},${y}`))) return false;
      }
      if (i === 0 && g.has(`${sx-dx},${sy-dy}`)) return false;
      if (i === word.length-1 && g.has(`${x+dx},${y+dy}`)) return false;
    }
    return true;
  }
  function placeWord(word, sx, sy, dx, dy, g) {
    const dir = dx === 1 ? 'h' : 'v';
    for (let i = 0; i < word.length; i++) {
      const x = sx + i * dx, y = sy + i * dy, k = `${x},${y}`;
      const ex = g.get(k);
      if (ex) ex.dirs.add(dir);
      else g.set(k, { letter: word[i], dirs: new Set([dir]) });
    }
  }
  function countCrossings(word, sx, sy, dx, dy, g) {
    let n = 0;
    for (let i = 0; i < word.length; i++) if (g.has(`${sx + i * dx},${sy + i * dy}`)) n++;
    return n;
  }
  /* ────────────────────────────────────────────
     Seeded RNG (mulberry32) — deterministic per seed
  ──────────────────────────────────────────── */
  function makeRandom(seed) {
    let s = (seed | 0) >>> 0;
    if (s === 0) s = 1;
    return function () {
      s = (s + 0x6D2B79F5) >>> 0;
      let t = Math.imul(s ^ (s >>> 15), 1 | s);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) >>> 0;
      t = t ^ (t >>> 14);
      return (t >>> 0) / 4294967296;
    };
  }

  /* Signature for detecting when two grids are the same layout */
  function gridSignature(g) {
    const keys = Array.from(g.keys()).sort();
    let s = '';
    for (const k of keys) s += k + ':' + g.get(k).letter + '|';
    return s;
  }

  /* Single-seed attempt. seed=0 → deterministic (original algo).
     seed>0 → shuffled first-word orientation, shuffled placement
     order, random pick among top-tier candidates.               */
  function tryBuildGrid(words, seed) {
    const g = new Map();
    if (words.length === 0) return { g, unplaced: [] };
    if (words.length === 1) {
      placeWord(words[0], 0, 0, 0, 1, g);
      return { g, unplaced: [] };
    }
    const rand = makeRandom(seed || 1);

    // First-word orientation
    let dx = 1, dy = 0;
    if (seed !== 0 && rand() < 0.5) { dx = 0; dy = 1; }
    placeWord(words[0], 0, 0, dx, dy, g);

    const unplaced = new Set(words.slice(1));
    let progress = true;
    while (progress && unplaced.size > 0) {
      progress = false;
      // Order to attempt words in — shuffled per pass in shuffle mode
      let order = [...unplaced];
      if (seed !== 0) {
        for (let i = order.length - 1; i > 0; i--) {
          const j = Math.floor(rand() * (i + 1));
          [order[i], order[j]] = [order[j], order[i]];
        }
      }
      for (const word of order) {
        const candidates = [];
        for (const [k, cell] of g.entries()) {
          const [x, y] = k.split(',').map(Number);
          for (let i = 0; i < word.length; i++) {
            if (word[i] !== cell.letter) continue;
            const vx = x, vy = y - i;
            if (canPlace(word, vx, vy, 0, 1, g)) {
              candidates.push({ sx: vx, sy: vy, dx: 0, dy: 1, crossings: countCrossings(word, vx, vy, 0, 1, g) });
            }
            const hx = x - i, hy = y;
            if (canPlace(word, hx, hy, 1, 0, g)) {
              candidates.push({ sx: hx, sy: hy, dx: 1, dy: 0, crossings: countCrossings(word, hx, hy, 1, 0, g) });
            }
          }
        }
        if (candidates.length > 0) {
          candidates.sort((a, b) => b.crossings - a.crossings);
          let picked;
          if (seed === 0) {
            picked = candidates[0];
          } else {
            // Random pick among top-tier (all with max crossings) — preserves quality
            const maxCross = candidates[0].crossings;
            const topTier = candidates.filter(c => c.crossings === maxCross);
            picked = topTier[Math.floor(rand() * topTier.length)];
          }
          placeWord(word, picked.sx, picked.sy, picked.dx, picked.dy, g);
          unplaced.delete(word);
          progress = true;
        }
      }
    }
    return { g, unplaced: [...unplaced] };
  }

  function buildGrid(lines) {
    let words = lines
      .map(w => w.trim().toUpperCase().replace(/[^A-Z]/g, ''))
      .filter(w => w.length > 0);
    if (!words.length) { setWarn(null); updateShuffleBtnState(0); return new Map(); }
    words.sort((a, b) => b.length - a.length);

    // In shuffle mode: try several seeds derived from shuffleSeed and keep
    // the best (any layout that places all words; if none does, keep the
    // one with the fewest unplaced words).
    const seeds = shuffleSeed === 0
      ? [0]
      : Array.from({ length: 8 }, function (_, i) { return shuffleSeed * 1013 + i * 61 + 1; });

    let best = null;
    for (const s of seeds) {
      const a = tryBuildGrid(words, s);
      if (!best || a.unplaced.length < best.unplaced.length) {
        best = a;
        if (a.unplaced.length === 0) break;
      }
    }

    setWarn(best.unplaced.length > 0 ? best.unplaced : null);
    updateShuffleBtnState(words.length);
    return best.g;
  }

  function updateShuffleBtnState(wordCount) {
    const btn = document.getElementById('shuffleBtn');
    if (btn) btn.disabled = wordCount < 2;
  }

  function setWarn(unplaced) {
    if (!unplaced || unplaced.length === 0) {
      warnEl.style.display = 'none';
    } else {
      warnTxt.textContent = `Can't place: ${unplaced.join(', ')}`;
      warnEl.style.display = 'flex';
    }
  }

  /* ────────────────────────────────────────────
     PREVIEW RENDER — fast path
     • title uses native <text> (no tracing)
     • tile silhouette uses SC=1 raster (~1MP)
     • letters use cached traced glyphs
  ──────────────────────────────────────────── */
  function renderPreview() {
    clr(svgEl);
    svgEl.setAttribute('viewBox', `0 0 ${BW} ${BH}`);
    if (!grid.size) grid.set('0,0', { letter: '?', dirs: new Set(['h']) });

    svgEl.appendChild(mkEl('rect', { x: 0, y: 0, width: BW, height: BH, rx: BR, ry: BR, fill: C_BG }));

    // Tree (tan fill, for visual)
    const treeSvg = mkEl('svg', { x: 0, y: 0, width: TREE_VW, height: BH, overflow: 'hidden' });
    const treeG = mkEl('g', { transform: `scale(${TREE_SCALE})` });
    treeG.appendChild(mkEl('path', { d: TREE_PATH_MAIN,   fill: C_TAN }));
    treeG.appendChild(mkEl('path', { d: TREE_PATH_BIRD,   fill: C_TAN }));
    treeG.appendChild(mkEl('path', { d: TREE_PATH_FLOWER, fill: C_TAN }));
    treeSvg.appendChild(treeG);
    svgEl.appendChild(treeSvg);

    const layout = computeLayout(grid);
    const { T, offX, offY, cols, rows, minX, gridCX, NAME_BASELINE } = layout;
    const sorted = Array.from(grid.keys()).sort((a, b) => {
      const [ax, ay] = a.split(',').map(Number), [bx, by] = b.split(',').map(Number);
      return ay - by || ax - bx;
    });

    // Tile silhouette (SC=1 — fast)
    const pd = computeTileSilhouettePath(sorted, offX, offY, T, 1);
    svgEl.appendChild(mkEl('path', { d: pd, fill: C_TILE, stroke: 'none', 'fill-rule': 'evenodd' }));

    // Individual tile outlines
    const outG = mkEl('g', { fill: 'none', stroke: C_BLACK, 'stroke-width': '1.8' });
    for (const k of sorted) {
      const [x, y] = k.split(',').map(Number);
      outG.appendChild(mkEl('rect', { x: offX + x * T, y: offY + y * T, width: T, height: T, rx: 7, ry: 7 }));
    }
    svgEl.appendChild(outG);

    // Letters and scores (traced glyphs — cached)
    const lSz = Math.round(T * 0.55);
    const nSz = Math.round(T * 0.20);
    const engG = mkEl('g', { fill: C_RED });
    for (const k of sorted) {
      const [x, y] = k.split(',').map(Number);
      const cell = grid.get(k);
      const sc = SCORES[cell.letter] !== undefined ? SCORES[cell.letter] : 0;
      const rx = offX + x * T, ry = offY + y * T;
      addCharPath(engG, cell.letter, rx + T/2, ry + T/2 - 1, lSz, C_RED);
      addNumPath(engG, sc, rx + T - 5, ry + T - 5 - nSz / 2, nSz, C_RED);
    }
    svgEl.appendChild(engG);

    // Title via native SVG <text> — INSTANT
    const NAME_WIN_L = 432, NAME_WIN_R = BW - 48;
    const NAME_WIN_W = NAME_WIN_R - NAME_WIN_L;
    const nameText = nameEl.value.trim() || 'Family Name';
    const measCv = document.createElement('canvas');
    const measCtx = measCv.getContext('2d');
    let fs = 88;
    measCtx.font = `${titleFont.weight} ${fs}px "${titleFont.family}", cursive`;
    while (fs >= 20 && measCtx.measureText(nameText).width > NAME_WIN_W) {
      fs -= 2;
      measCtx.font = `${titleFont.weight} ${fs}px "${titleFont.family}", cursive`;
    }
    const textW = measCtx.measureText(nameText).width;
    const halfW = textW / 2;
    const clampedCX = Math.max(NAME_WIN_L + halfW, Math.min(NAME_WIN_R - halfW, gridCX));
    const titleEl = mkEl('text', {
      x: clampedCX,
      y: NAME_BASELINE,
      'font-family': `"${titleFont.family}", cursive`,
      'font-weight': titleFont.weight,
      'font-size': fs,
      'text-anchor': 'middle',
      fill: C_TAN
    });
    titleEl.textContent = nameText;
    svgEl.appendChild(titleEl);
  }

  /* ────────────────────────────────────────────
     EXPORT SVG BUILDER
     • Legend at top (Red-CUT / Black-ENGRAVE / Blue-SCORE)
     • Layer 1: board outline only (red cut)
     • Layer 2: tree + tile silhouette + score lines +
                letters/numbers + traced family name
     • Labels beneath each layer
  ──────────────────────────────────────────── */
  function buildExportSVG() {
    // Ensure the placeholder grid isn't leaked into the export
    let g = grid;
    if (g.size === 1 && g.get('0,0') && g.get('0,0').letter === '?') g = new Map();
    if (g.size === 0) return null;

    const sortedKeys = Array.from(g.keys()).sort((a, b) => {
      const [ax, ay] = a.split(',').map(Number), [bx, by] = b.split(',').map(Number);
      return ay - by || ax - bx;
    });

    // Re-run layout math on the "real" grid (in case we substituted the placeholder above)
    const savedGrid = grid;
    grid = g;
    const layout = computeLayout(g);
    const { T, offX, offY, gridCX, NAME_BASELINE } = layout;

    // Tile silhouette at high quality
    const silhouetteD = computeTileSilhouettePath(sortedKeys, offX, offY, T, 4);

    // Internal score lines
    const scoreLines = computeScoreLines(offX, offY, T);

    // Traced family name
    const NAME_WIN_L = 432, NAME_WIN_R = BW - 48;
    const NAME_WIN_W = NAME_WIN_R - NAME_WIN_L;
    const nameText = nameEl.value.trim() || 'Family Name';
    const nameD = renderNameTraced(nameText, NAME_WIN_W, NAME_WIN_L, NAME_WIN_R, gridCX, NAME_BASELINE);

    // Letter + score paths — built as an in-memory <g> using DOM to reuse addChar/addNum
    const letterG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    letterG.setAttribute('fill', C_BLACK);
    letterG.setAttribute('stroke', 'none');
    const lSz = Math.round(T * 0.55);
    const nSz = Math.round(T * 0.20);
    for (const k of sortedKeys) {
      const [x, y] = k.split(',').map(Number);
      const cell = g.get(k);
      const sc = SCORES[cell.letter] !== undefined ? SCORES[cell.letter] : 0;
      const rx = offX + x * T, ry = offY + y * T;
      addCharPath(letterG, cell.letter, rx + T/2, ry + T/2 - 1, lSz, C_BLACK);
      addNumPath(letterG, sc, rx + T - 5, ry + T - 5 - nSz / 2, nSz, C_BLACK);
    }

    grid = savedGrid;

    /* ── Layout the export artboard ──
       PAD_TOP + LEGEND_H + GAP_L + BH + LABEL_GAP + LABEL_H + GAP_LAYER
       + BH + LABEL_GAP + LABEL_H + PAD_BOTTOM
       Width: BW + PAD_SIDE * 2
    */
    const PAD_SIDE   = 60;
    const PAD_TOP    = 60;
    const PAD_BOTTOM = 60;
    const LEGEND_H   = 90;
    const GAP_L      = 50;    // legend → layer 1
    const LABEL_GAP  = 20;    // layer → its label
    const LABEL_H    = 40;
    const GAP_LAYER  = 70;    // between layer 1 label and layer 2

    const layer1Y = PAD_TOP + LEGEND_H + GAP_L;
    const layer1LabelY = layer1Y + BH + LABEL_GAP + LABEL_H / 2;
    const layer2Y = layer1Y + BH + LABEL_GAP + LABEL_H + GAP_LAYER;
    const layer2LabelY = layer2Y + BH + LABEL_GAP + LABEL_H / 2;

    const totalW = BW + PAD_SIDE * 2;
    const totalH = layer2LabelY + LABEL_H / 2 + PAD_BOTTOM;

    // Build SVG string
    const legendCX = totalW / 2;
    const legendY  = PAD_TOP + LEGEND_H / 2;
    const legendFS = 34;

    // Serialize letterG to an XML string
    const serializer = new XMLSerializer();
    const letterXML = serializer.serializeToString(letterG);

    // Layer 1: board outline (red cut, no fill)
    const layer1XML =
      `<g id="layer-1" transform="translate(${PAD_SIDE},${layer1Y})">` +
        `<rect x="0" y="0" width="${BW}" height="${BH}" rx="${BR}" ry="${BR}" ` +
        `stroke="${C_RED}" stroke-width="1" fill="none"/>` +
      `</g>`;

    // Layer 2: everything else, positioned as it would sit on the board
    const treeXML =
      `<g transform="scale(${TREE_SCALE})">` +
        `<path d="${TREE_PATH_MAIN}"   stroke="${C_RED}" stroke-width="1" fill="none"/>` +
        `<path d="${TREE_PATH_BIRD}"   stroke="${C_RED}" stroke-width="1" fill="none"/>` +
        `<path d="${TREE_PATH_FLOWER}" stroke="${C_RED}" stroke-width="1" fill="none"/>` +
      `</g>`;

    let scoreLinesXML = '';
    if (scoreLines.length) {
      scoreLinesXML = `<g stroke="${C_BLUE}" stroke-width="1" fill="none">` +
        scoreLines.map(l => `<line x1="${l.x1.toFixed(2)}" y1="${l.y1.toFixed(2)}" x2="${l.x2.toFixed(2)}" y2="${l.y2.toFixed(2)}"/>`).join('') +
        `</g>`;
    }

    const tileCutXML = `<path d="${silhouetteD}" stroke="${C_RED}" stroke-width="1" fill="none" fill-rule="evenodd"/>`;

    const nameXML = nameD
      ? `<path d="${nameD}" stroke="${C_RED}" stroke-width="1" fill="none" fill-rule="evenodd"/>`
      : '';

    const layer2XML =
      `<g id="layer-2" transform="translate(${PAD_SIDE},${layer2Y})">` +
        treeXML +
        tileCutXML +
        scoreLinesXML +
        letterXML +
        nameXML +
      `</g>`;

    // Legend — informational (users should exclude this from cut in laser software)
    const legendXML =
      `<g id="legend-informational" font-family="Arial, sans-serif" font-weight="700" font-size="${legendFS}" text-anchor="middle" dominant-baseline="middle">` +
        `<text x="${legendCX - 280}" y="${legendY}" fill="${C_RED}">Red — CUT</text>` +
        `<text x="${legendCX}"       y="${legendY}" fill="${C_BLACK}">Black — ENGRAVE</text>` +
        `<text x="${legendCX + 280}" y="${legendY}" fill="${C_BLUE}">Blue — SCORE</text>` +
      `</g>`;

    // Layer labels — informational
    const labelsXML =
      `<g id="layer-labels" font-family="Arial, sans-serif" font-weight="700" font-size="26" text-anchor="middle" dominant-baseline="middle" fill="#555">` +
        `<text x="${totalW / 2}" y="${layer1LabelY}">Layer 1 — Board</text>` +
        `<text x="${totalW / 2}" y="${layer2LabelY}">Layer 2 — Assembly</text>` +
      `</g>`;

    // Compute physical dimensions from the width input
    const val = parseFloat(widthEl.value) || 11.8;
    const unit = currentUnit; // 'in' | 'cm'
    // Design was 11.8"×8.8" on 1133×845 → 96 dpi. We scale accordingly.
    const scaleFactor = val / BW * (BW); // display width in physical units
    const wPhys = (totalW * (val / BW)).toFixed(3);
    const hPhys = (totalH * (val / BW)).toFixed(3);

    const svgXML =
      `<?xml version="1.0" encoding="UTF-8"?>\n` +
      `<svg xmlns="http://www.w3.org/2000/svg" ` +
        `width="${wPhys}${unit}" height="${hPhys}${unit}" ` +
        `viewBox="0 0 ${totalW} ${totalH}">` +
        legendXML +
        layer1XML +
        layer2XML +
        labelsXML +
      `</svg>`;

    return {
      xml: svgXML,
      wPhys, hPhys,
      unit,
      boardWidth: val
    };
  }

  /* ────────────────────────────────────────────
     SAVE
  ──────────────────────────────────────────── */
  function saveSVG() {
    if (!grid.size || (grid.size === 1 && grid.get('0,0') && grid.get('0,0').letter === '?')) {
      alert('Type at least one word to save.');
      return;
    }
    const ex = buildExportSVG();
    if (!ex) { alert('Nothing to export.'); return; }
    const blob = new Blob([ex.xml], { type: 'image/svg+xml' });
    const url  = URL.createObjectURL(blob);
    const fname = `family_crossword_${ex.boardWidth}${ex.unit}.svg`;
    const a = Object.assign(document.createElement('a'), { href: url, download: fname });
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  /* ────────────────────────────────────────────
     UNIT HANDLING
  ──────────────────────────────────────────── */
  function updateDimHint() {
    const val = parseFloat(widthEl.value) || 0;
    const ratio = 8.8 / 11.8;
    const h = val * ratio;
    const u = currentUnit === 'in' ? '″' : ' cm';
    const uu = currentUnit === 'in' ? '″' : ' cm';
    dimHint.textContent = `${val.toFixed(currentUnit === 'in' ? 1 : 2)}${uu} × ${h.toFixed(2)}${uu}  (aspect ratio 1.34 : 1)`;
  }
  function switchUnit(newUnit) {
    if (newUnit === currentUnit) return;
    const val = parseFloat(widthEl.value) || 0;
    let newVal;
    if (newUnit === 'cm' && currentUnit === 'in') newVal = val * 2.54;
    else if (newUnit === 'in' && currentUnit === 'cm') newVal = val / 2.54;
    else newVal = val;
    widthEl.value = newVal.toFixed(newUnit === 'in' ? 1 : 2);
    widthEl.step = newUnit === 'in' ? '0.1' : '0.25';
    if (newUnit === 'in') {
      widthEl.min = '4'; widthEl.max = '48';
    } else {
      widthEl.min = '10'; widthEl.max = '122';
    }
    currentUnit = newUnit;
    unitSeg.querySelectorAll('.sb').forEach(b => {
      b.classList.toggle('on', b.dataset.unit === newUnit);
    });
    updateDimHint();
  }

  /* ────────────────────────────────────────────
     FONT DROPDOWN
  ──────────────────────────────────────────── */
  function initFontDropdown(root, options, initialLabel, onChange) {
    const trigger = root.querySelector('.font-select-trigger');
    const valueEl = root.querySelector('.font-select-value');
    const menu    = root.querySelector('.font-select-menu');
    menu.innerHTML = '';
    options.forEach(opt => {
      const li = document.createElement('li');
      li.className = 'font-select-option';
      li.setAttribute('role', 'option');
      li.textContent = opt.label;
      li.style.fontFamily = `"${opt.family}", cursive, serif`;
      if (opt.weight) li.style.fontWeight = opt.weight;
      if (opt.label === initialLabel) li.classList.add('selected');
      li.addEventListener('click', () => {
        valueEl.textContent = opt.label;
        valueEl.style.fontFamily = `"${opt.family}", cursive, serif`;
        if (opt.weight) valueEl.style.fontWeight = opt.weight;
        menu.querySelectorAll('.font-select-option').forEach(el => el.classList.remove('selected'));
        li.classList.add('selected');
        root.classList.remove('open');
        trigger.setAttribute('aria-expanded', 'false');
        onChange(opt);
      });
      menu.appendChild(li);
    });
    const initial = options.find(o => o.label === initialLabel) || options[0];
    valueEl.textContent = initial.label;
    valueEl.style.fontFamily = `"${initial.family}", cursive, serif`;
    if (initial.weight) valueEl.style.fontWeight = initial.weight;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = root.classList.toggle('open');
      trigger.setAttribute('aria-expanded', String(isOpen));
      document.querySelectorAll('.font-select.open').forEach(el => {
        if (el !== root) { el.classList.remove('open'); el.querySelector('.font-select-trigger').setAttribute('aria-expanded', 'false'); }
      });
    });
  }
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.font-select.open').forEach(root => {
      if (!root.contains(e.target)) {
        root.classList.remove('open');
        root.querySelector('.font-select-trigger').setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ────────────────────────────────────────────
     REAL-TIME (rAF throttle → instant feel)
  ──────────────────────────────────────────── */
  let rafId = null;
  function scheduleRender() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      if (!fontsReady) return;
      grid = buildGrid(wordEl.value.split('\n'));
      renderPreview();
    });
  }

  /* ────────────────────────────────────────────
     EVENTS
  ──────────────────────────────────────────── */
  document.getElementById('saveBtn').addEventListener('click', saveSVG);
  widthEl.addEventListener('input', updateDimHint);
  wordEl.addEventListener('input', scheduleRender);
  nameEl.addEventListener('input', scheduleRender);
  unitSeg.querySelectorAll('.sb').forEach(b => {
    b.addEventListener('click', () => switchUnit(b.dataset.unit));
  });

  // Shuffle: pick a fresh random seed that (ideally) produces a layout
  // different from the current one. We try a few candidates and check
  // the resulting grid's signature; if none differ, we still commit
  // the last candidate so the click has *some* effect.
  document.getElementById('shuffleBtn').addEventListener('click', () => {
    const words = wordEl.value.split('\n')
      .map(w => w.trim().toUpperCase().replace(/[^A-Z]/g, ''))
      .filter(w => w.length > 0);
    if (words.length < 2) return;
    words.sort((a, b) => b.length - a.length);

    const currentSig = gridSignature(grid);
    let chosenSeed = 0;
    for (let attempt = 0; attempt < 12; attempt++) {
      const candidate = Math.floor(Math.random() * 1e9) + 1;
      // Preview what the candidate would produce (single-seed try is enough for a diff check)
      const preview = tryBuildGrid(words, candidate);
      chosenSeed = candidate;
      if (gridSignature(preview.g) !== currentSig) break;
    }
    shuffleSeed = chosenSeed;

    // Little spin flourish on the icon
    const btn = document.getElementById('shuffleBtn');
    btn.classList.remove('spinning');
    void btn.offsetWidth; // restart CSS animation
    btn.classList.add('spinning');
    setTimeout(() => btn.classList.remove('spinning'), 550);

    scheduleRender();
  });

  initFontDropdown(
    document.getElementById('titleFontSelect'),
    TITLE_FONTS, titleFont.label,
    (opt) => {
      titleFont = opt;
      document.fonts.load(`${opt.weight} 88px "${opt.family}"`).finally(() => {
        if (fontsReady) renderPreview();
      });
    }
  );
  initFontDropdown(
    document.getElementById('crosswordFontSelect'),
    CROSSWORD_FONTS, crosswordFont.label,
    (opt) => {
      crosswordFont = opt;
      document.fonts.load(`${opt.weight} 100px "${opt.family}"`).finally(() => {
        if (fontsReady) renderPreview();
      });
    }
  );

  /* ────────────────────────────────────────────
     INIT
  ──────────────────────────────────────────── */
  const preloads = [];
  TITLE_FONTS.forEach(f => preloads.push(document.fonts.load(`${f.weight} 88px "${f.family}"`)));
  CROSSWORD_FONTS.forEach(f => preloads.push(document.fonts.load(`${f.weight} 100px "${f.family}"`)));
  Promise.allSettled(preloads).then(() => {
    fontsReady = true;
    grid = buildGrid(wordEl.value.split('\n'));
    renderPreview();
  });

})();